import { render, staticRenderFns } from "./DialogGatewayValue.vue?vue&type=template&id=b97424de&"
import script from "./DialogGatewayValue.vue?vue&type=script&lang=js&"
export * from "./DialogGatewayValue.vue?vue&type=script&lang=js&"
import style0 from "./DialogGatewayValue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports